"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedIframeUi = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
/**
 * Component capable of rendering the `EmbedModule`
 * with the version set to `EmbedVersion.Iframe`.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let EmbedIframeUi = class EmbedIframeUi extends vue_property_decorator_1.Vue {
    /**
     * Protects you from accessing an undefined variable.
     *
     * @returns - `this.iframe` if it exists
     * @returns - Empty string, if this.iframe hasn't been defined or is broken.
     */
    get html() {
        return typeof this.iframe === 'string' && this.iframe.length > 0
            ? this.iframe
            : '';
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: false }),
    __metadata("design:type", Object)
], EmbedIframeUi.prototype, "description", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: true }),
    __metadata("design:type", Object)
], EmbedIframeUi.prototype, "iframe", void 0);
EmbedIframeUi = __decorate([
    vue_property_decorator_1.Component({
        name: 'EmbedIframeUi',
        mounted() {
            this.$emit('ready');
        },
        template: `
    <figure>
      <div v-html="html" />
      <figcaption v-if="description" class="small">{{ description }}</figcaption>
    </figure>
  `
    })
], EmbedIframeUi);
exports.EmbedIframeUi = EmbedIframeUi;
//# sourceMappingURL=EmbedIframe.ui.js.map